(function () {
  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = f.querySelector('[type="submit"]');
      if (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.style.opacity = '0.7';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(f),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    },
    true
  );
})();
